export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-20.jpg'),
        title: 'AI视频制作',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'AI视频制作',
      description: `<p >在数字内容爆发式增长的当下，AI技术已彻底重构视频制作的产业逻辑，将传统制作流程中的效率瓶颈、成本高企、创意局限等痛点逐一破解。AI视频制作公司凭借“技术+创意+服务”的核心竞争力，为各行业客户提供从需求洞察到效果落地的全链路视频解决方案，实现内容生产效率提升300%、成本降低50%以上的价值突破，成为品牌传播与场景落地的核心伙伴。</p>
<p>针对中小微企业“快速试错、低预算”需求，提供轻量化、模板化批量生产服务，实现高效落地。搭载千余套行业模板，覆盖门店引流、活动宣传、直播切片等核心场景，客户仅需上传基础素材，AI可自动完成拼接、字幕添加、背景音乐生成，5分钟内输出适配抖音、微信、小红书等多平台的格式（9:16竖屏、16:9横屏、1:1正方形）视频，支持720P/1080P高清输出。</p>`
    },
    {
      title: '我们的优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-20.jpg')+`)"></span>
      <span class="list">
      <i></i>用 AI 驱动的智能脚本与分镜生成，大幅缩短制作周期，让创意更快落地。<br/>
      <i></i>自动匹配风格化视觉效果，从写实到二次元一键切换，满足多场景需求。<br/>
      <i></i>成本更低、迭代更快，让小预算也能做出大片质感。<br/>
      <i></i>智能配音、字幕与画面自动对齐，让视频制作更高效、更省心。<br/>
      <i></i>支持批量生成多版本视频，适配不同平台与投放需求。<br/>
      </span>`
    }
  ]
}
